import { z } from "zod";
import { firestoreTimestampSchema } from "./common.schema";

export const doctorSignatureMetadataSchema = z.object({
  storagePath: z.string().min(1),
  contentType: z.literal("image/png"),
  sha256: z.string().regex(/^[a-f0-9]{64}$/),
  version: z.string().min(1),
  updatedAt: firestoreTimestampSchema,
  updatedBy: z.string().min(1),
});

export type DoctorSignatureMetadata = z.infer<
  typeof doctorSignatureMetadataSchema
>;

export const doctorSignatureResponseSchema = z.object({
  url: z.string(),
});

export type DoctorSignatureResponse = z.infer<
  typeof doctorSignatureResponseSchema
>;

export const employerSignatureAssetMetadataSchema = z.object({
  storagePath: z.string().min(1),
  contentType: z.literal("image/png"),
  sha256: z.string().regex(/^[a-f0-9]{64}$/),
  version: z.string().min(1),
  updatedAt: firestoreTimestampSchema,
});

export type EmployerSignatureAssetMetadata = z.infer<
  typeof employerSignatureAssetMetadataSchema
>;

export const contractSignatureSnapshotSchema = z.object({
  employerAssetVersion: z.string().min(1),
  employerSha256: z.string().regex(/^[a-f0-9]{64}$/),
  doctorSource: z.enum(["profile", "dialog", "none"]),
  doctorSha256: z
    .string()
    .regex(/^[a-f0-9]{64}$/)
    .optional(),
  doctorUserId: z.string().min(1),
});

export type ContractSignatureSnapshot = z.infer<
  typeof contractSignatureSnapshotSchema
>;

export const doctorSignatureModeSchema = z.enum(["auto", "override", "none"]);
export type DoctorSignatureMode = z.infer<typeof doctorSignatureModeSchema>;
